import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { ASSET_TYPE_OPTIONS } from '../../types/assets';

export type AssetTypeFilterValue = 'all' | (typeof ASSET_TYPE_OPTIONS)[number];

interface AssetTypeFilterProps {
  value: AssetTypeFilterValue;
  onChange: (value: AssetTypeFilterValue) => void;
}

const AssetTypeFilter: React.FC<AssetTypeFilterProps> = ({ value, onChange }) => (
  <FormControl size="small" sx={{ minWidth: 180 }}>
    <InputLabel id="asset-type-filter-label" sx={{ fontSize: '0.875rem' }}>
      Asset Type
    </InputLabel>
    <Select
      labelId="asset-type-filter-label"
      label="Asset Type"
      value={value}
      onChange={e => onChange(e.target.value as AssetTypeFilterValue)}
      sx={{
        fontSize: '0.875rem',
        '& .MuiSelect-select': { fontSize: '0.875rem' },
      }}
      MenuProps={{
        PaperProps: {
          sx: { '& .MuiMenuItem-root': { fontSize: '0.875rem' } },
        },
      }}
    >
      <MenuItem value="all">All</MenuItem>
      {ASSET_TYPE_OPTIONS.map(type => (
        <MenuItem key={type} value={type}>
          {type}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default AssetTypeFilter;
